import { TemplateElement, html, defineElement } from '@webtides/element-js';

/**
 * @property {string} headline
 * @property {string} text
 */
export default class ComponentIntro extends TemplateElement {
    properties() {
        return {
            headline: '',
            text: '',
        };
    }

    styles() {
        return [`mb-component-intro {display: block;}`];
    }

    template() {
        return html`
            <h2 class="mb-16">${this.headline}</h2>
            <p class="text-green-light text-base md:text-xl mb-0">${this.text}</p>
        `;
    }
}

defineElement('mb-component-intro', ComponentIntro);
